import { queryOptions } from '@tanstack/react-query';
import * as api from './users.api';
import { createQueryKeys } from '@/lib/query-factory';

const keys = createQueryKeys('users');

export const userQueries = {
  keys,

  list: () =>
    queryOptions({
      queryKey: keys.list(),
      queryFn: () => api.fetchUsers(),
    }),
};
